import { Button, Card, CardContent, Chip, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { FormProvider, RHFCheckbox, RHFFileField, RHFTextField } from "../../common/hook-form";
import { useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { apiConstants, post, postMultipart } from "../../common/constants";
import { useSnackbar } from "notistack";
import PageTitle from "../PageTitle";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';
import { formatDate2, } from "../../common/util";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import { parseDateAndTime } from "../../helpers/UtilityHelper";
import Loader from '../../common/Loader';
import MUIModal from "../MuiModal";
import DownloadSampleFile from "../DownloadSampleFile";
import EditIcon from '@mui/icons-material/Edit';
import NotificationForm from "./NotificationForm";

function PushNotification() {
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(0)
    const [notificationList, setNotificationList] = useState([])
    const [open, setOpen] = useState(false);
    const [edit, setEditData] = useState(null);



    const editModal = (val) => {
        setOpen(true);
        setEditData(val)
    };

    const handleClose = () => {
        setOpen(false)
        setEditData(null)
    }

    useEffect(() => {
        setIsLoading(true)
        post(`${apiConstants.GET_NOTIFICATION}`, {
            "andfilter": [],
            "limit": sizePerPage,
            "offset": sizePerPage * page
        }).then((res) => {
            const notiList = res?.data?.data.length > 0 ? res?.data?.data.filter((val) => val.destination === "PUSH") : []
            setNotificationList(notiList)
            setIsLoading(false)
        }).catch((err) => {
            console.log(err)
            setIsLoading(false)
        })
    }, [reload, sizePerPage, page])

    const Columns = [
        {
            field: 'header',
            headerName: 'Header',
            flex: 1.5,
            renderCell: (col) => {
                const { row } = col;
                const headerText = row?.header || '';
                return headerText.length > 100 ? (
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            <span>{headerText.substring(0, 100)}&hellip;</span>
                            <Tooltip title={headerText} arrow>
                                <span style={{ borderBottom: '1px dashed #007bff', cursor: 'pointer', marginLeft: 2, color: 'blue' }}>
                                    more
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12}>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            {headerText}
                        </Grid>
                        <Grid item xs={12}>
                        </Grid>
                    </Grid>
                );
            }
        },
        {
            field: 'text',
            headerName: 'Text',
            flex: 1.8,
            renderCell: (col) => {
                const { row } = col;
                const descriptionText = row?.text || '';
                return descriptionText.length > 100 ? (
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            <span>{descriptionText.substring(0, 100)}&hellip;</span>
                            <Tooltip title={descriptionText} sx={{ overflow: 'auto', maxHeight: 200 }} arrow>
                                <span style={{ borderBottom: '1px dashed #007bff', cursor: 'pointer', marginLeft: 2, color: 'blue' }}>
                                    more
                                </span>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={12}>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            {descriptionText}
                        </Grid>
                        <Grid item xs={12}>
                        </Grid>
                    </Grid>
                );
            }
        },
        {
            field: 'text1',
            headerName: 'Button Name',
            flex: 1,
            renderCell: (col) => {
                const { row } = col
                return row.text1
            }

        },
        {
            field: 'description',
            headerName: 'Link',
            flex: 0.6,
            renderCell: (col) => {
                const { row } = col;
                return (
                    <>
                        {row.text1 && row.description ? (
                            <Tooltip title={row.text1} arrow>
                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => window.open(row.description, '_blank')}
                                >
                                    View
                                </Button>
                            </Tooltip>
                        ) : '-'}
                    </>
                )

            }
        },
        // {
        //     field: 'eddResponseFileLink', headerAlign: "left", hideSortIcons: true, headerName: 'Response File', flex: 1, renderCell: (params) => {
        //         const { row } = params;
        //         return (
        //             <Link href={row?.eddResponseFileLink} target='_blank'>Response File</Link>
        //         )
        //     },
        // },
        {
            field: 'eddResponseFileLink', headerAlign: "left", hideSortIcons: true, headerName: 'Response File', flex: 1, renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        {row?.eddResponseFileLink ? (
                            <Tooltip title={row.text1} arrow>
                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => window.open(row?.eddResponseFileLink, '_blank')}
                                >
                                    View
                                </Button>
                            </Tooltip>
                        ) : '-'}
                    </>
                )
            },
        },
        {
            field: 'eddUploadedFileLink', headerAlign: "left", hideSortIcons: true, headerName: 'Uploaded File', flex: 1, renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        {row?.eddUploadedFileLink ? (
                            <Tooltip title={row.text1} arrow>
                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => window.open(row?.eddUploadedFileLink, '_blank')}
                                >
                                    View
                                </Button>
                            </Tooltip>
                        ) : '-'}
                    </>
                )
            },
        },
        {
            field: 'createdByUser',
            headerName: 'Created By',
            flex: 1.3,
        },
        {
            field: 'createdDate',
            headerName: 'Created Date',
            flex: 1,
            renderCell: (col) => {
                const { row } = col
                return row.createdDate ? parseDateAndTime(row.createdDate) : '-'
            }
        },
        {
            field: 'active',
            headerName: 'Status ',
            flex: 0.8,
            renderCell: (col) => {
                const { row } = col
                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Chip color={row.active ? "success" : "error"} size="small" label={row.active ? "Active" : "Inactive"} />
                            </Grid>
                        </Grid>
                    </>
                )
            }
        },
        {
            field: 'action',
            headerName: 'Action ',
            flex: 0.6,
            renderCell: (col) => {
                const { row } = col
                return (
                    <>
                        <Tooltip title="Edit">
                            <IconButton onClick={() => editModal(row)} color="primary" size="small">
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </>
                )
            }
        },
    ]

    return (
        <>
            {isLoading && <Loader />}
            <PageTitle>Notification Configuration</PageTitle>
            <MUIModal
                open={open}
                handleClose={handleClose}
                children={
                    <>
                        <NotificationForm
                            handleClose={handleClose}
                            setReload={setReload}
                            edit={edit}
                        />
                    </>}
                title={"Edit Details"}
                maxWidth='lg'
            />
            <Grid paddingBottom={2}>
                <Card>
                    <CardContent>
                        <NotificationForm setReload={setReload} />
                    </CardContent>
                </Card>
            </Grid >
            <Card>
                <CardContent>
                    <ProzoDataGrid
                        columns={Columns}
                        autoHeight={true}
                        rows={notificationList || []}
                        sizePerPage={sizePerPage}
                        setSizePerPage={setSizePerPage}
                        setPage={setPage}
                        page={page}
                        pagination={true}
                        paginationMode={'server'}
                        rowHeight={120}
                        rowCount={Number.MAX_VALUE}
                        getRowId={(row) => row.id}
                    />
                </CardContent>
            </Card>
        </>
    )
}

export default PushNotification;


